import Cookies from "js-cookie";
import axios from "axios";
import { BACKEND_URL } from "./apiConfig";
import { log } from "../utils/logger";
    




type getOrdersOpts = {
    subscriberId: string | number | null
};
export async function getPastOrders({subscriberId}: getOrdersOpts): Promise<any> {
    // Normal fetch
    const token = Cookies.get("CatermatAuthToken");
    if (!token) {
        throw new Error("No authentication token found. Please log in.");
    }
    if (!subscriberId) {
        throw new Error("No subscriber id.");
    }
    try {
        const response = await axios.get(`${BACKEND_URL}/eshop/carts/previous_orders?subscriber_id=${subscriberId}`, {
            headers: {
                Accept: '*/*',
                Authorization: `Bearer ${token}`
            },
        });
        return response.data;
    } catch (error: any) {
        throw new Error(`Error ${error.response.status}: ${error.response.statusText}`);
    }
}
